module.exports = __webpack_public_path__ + "static/media/Blou 9.b68f3a2a.png";